import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import { Box } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

import { LayoutModule } from '../../../../layout/modules';
import { useFraudModeDetail } from './hook';
import { FraudModeData } from './data';
import { FraudModeParamsHistorical } from '../historical';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import { isOnlyViewProfile } from '../../../../../shared/types/profiles';
import {
    FRAUD_MODE_NEW,
    FRAUD_MODE,
    FRAUD_MODE_EDIT,
    FRAUD_MODE_DETAIL,
} from '../../../../../routes/paths';
import { FraudModeRegisterHistory } from './registerHistory';

export const FraudModeDetail = () => {
    const {
        fraudMode,
        fraudModeHistorical,
        showHistorical,
        setShowHistorical,
    } = useFraudModeDetail();

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    return (
        <>
            <LayoutModule
                title="Detalle modalidad fraude"
                withAccordion={false}
                additionalButtons={
                    <ActionButtonGroup
                        id={fraudMode?.id || ''}
                        buttonCreate={{
                            show: !isOnlyViewProfile(type),
                            route: FRAUD_MODE_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: FRAUD_MODE,
                        }}
                        buttonUpdate={{
                            show: !isOnlyViewProfile(type),
                            route: FRAUD_MODE_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: FRAUD_MODE_DETAIL,
                        }}
                        buttonLog={{
                            show: Boolean(fraudMode?.id),
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            >
                {showHistorical && (
                    <Box sx={{ marginTop: 2 }}>
                        <FraudModeParamsHistorical
                            historical={fraudModeHistorical ?? []}
                            showHistorical={true}
                        />
                    </Box>
                )}
                <LayoutModule
                    title=""
                    showTitle={false}
                    titleChildren="Información general"
                    icon={<PersonIcon sx={{ color: 'primary.main' }} />}
                >
                    <FraudModeData data={fraudMode} />
                </LayoutModule>
            </LayoutModule>
            <FraudModeRegisterHistory fraudMode={fraudMode} />
        </>
    );
};
